import { StrictMode } from 'react'
import './i18n'
import { createRoot } from 'react-dom/client'
import './index.css'
import App from './App.tsx'
import { registerWebMcpTools } from './lib/webmcp'

// After a new Pages deploy, cached entry JS may reference removed chunk hashes.
// Reload once so the browser picks up the fresh index.html + asset map.
window.addEventListener('vite:preloadError', (event) => {
  event.preventDefault()
  window.location.reload()
})

registerWebMcpTools()

createRoot(document.getElementById('root')!).render(
  <StrictMode>
    <App />
  </StrictMode>,
)
